module.exports = __webpack_public_path__ + "static/media/chargeDetails.29953a26.jpg";